import CloseIcon from '@mui/icons-material/Close';
import { Button, Stack, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import { useColors } from 'legacyfrontend/hooks/useColors';
import DateRangeSelector from './DateRangeSelector';
import Switch from 'react-switch';
import { getDisabledDates } from 'legacyfrontend/utils/dateUtils';

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction='up' ref={ref} {...props} />;
});

const safeDate = (val) => {
  if (!val) return undefined;
  const d = val instanceof Date ? val : new Date(val);
  return isNaN(d) ? undefined : d;
};

const DatePickerFullScreenDialog = ({
  startDate,
  endDate,
  isOpen,
  setShouldPasajerosOpen,
  isDatesEmpty,
  isOnlyOneWay,
  onChange,
  departureDate,
  handleSwitchChange,
}) => {
  const [open, setOpen] = React.useState(false);

  const { background } = useColors();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (isOpen) {
      setOpen(true);
    }
  }, [isOpen]);

  const handleNext = () => {
    setShouldPasajerosOpen(true);
    setTimeout(() => {
      setShouldPasajerosOpen(false);
    }, 200);
    handleClose();
  };

  return (
    <>
      <div
        className={`pasajeros-box-container ${isDatesEmpty ? 'dates-empty' : ''}`}
        onClick={handleClickOpen}
        style={{ width: '100%', paddingRight: 35, gap: 10 }}
      >
        <div style={{ flex: 1 }}>
          <p style={{ color: '#484848cc' }}>
            {startDate ? startDate.toLocaleDateString('es-ES') : 'Ida'}
          </p>
        </div>
        {!isOnlyOneWay && (
          <>
            <svg
              className='DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1'
              focusable='false'
              style={{ width: 35 }}
              viewBox='0 0 1000 1000'
            >
              <path d='M694 242l249 250c12 11 12 21 1 32L694 773c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210-210H68c-13 0-23-10-23-23s10-23 23-23h806L662 275c-21-22 11-54 32-33z' />
            </svg>
            <div style={{ flex: 1 }}>
              <p style={{ color: '#484848cc' }}>
                {endDate ? endDate.toLocaleDateString('es-ES') : 'Vuelta'}
              </p>
            </div>
          </>
        )}
      </div>

      <Dialog
        TransitionComponent={Transition}
        disableEnforceFocus
        disableScrollLock={false}
        fullScreen
        onClose={handleClose}
        open={open}
        slotProps={{
          backdrop: {
            style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          },
        }}
      >
        <AppBar sx={{ position: 'relative', backgroundColor: background }}>
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose}>
              <CloseIcon />
              <Typography component='div' sx={{ ml: 2, flex: 1 }} variant='h6'>
                {isOnlyOneWay ? 'Fecha de ida' : 'Fechas'}
              </Typography>
            </IconButton>
            {(isOnlyOneWay && startDate) || (!isOnlyOneWay && startDate && endDate) ? (
              <Button autoFocus color='inherit' onClick={handleNext}>
                Siguiente
              </Button>
            ) : null}
          </Toolbar>
        </AppBar>
        <DialogContent
          sx={{
            overflowY: 'scroll',
            maxHeight: '90vh',
            padding: '20px',
          }}
        >
          <Stack alignItems='center' direction='row' mb={2} spacing={1}>
            <Typography>Solo ida</Typography>
            <Switch checked={isOnlyOneWay} height={16} onChange={handleSwitchChange} width={32} />
          </Stack>

          <DateRangeSelector
            departureDate={departureDate}
            endDate={isOnlyOneWay ? undefined : safeDate(endDate)}
            error={isDatesEmpty}
            helperText={
              isDatesEmpty
                ? isOnlyOneWay
                  ? 'Selecciona la fecha de ida'
                  : 'Selecciona las fechas'
                : ''
            }
            isOneWay={isOnlyOneWay}
            months={1}
            disabledDates={getDisabledDates()}
            onChange={({ startDate: newStart, endDate: newEnd }) => {
              onChange({
                startDate: newStart,
                endDate: isOnlyOneWay ? null : newEnd,
              });
            }}
            startDate={safeDate(startDate)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DatePickerFullScreenDialog;
